import type { I3DEngine } from '@/application/ports/I3DEngine';
import type { ICameraController } from '@/application/ports/ICameraController';
import type { IFoldableStrategy } from '@/application/ports/IFoldableStrategy';
import type { IViewportEngine3D } from '@/application/ports/IViewportEngine3D';
import type { TCanvasSnapshot } from '@/application/ports/TCanvasSnapshot';
import type { TSide } from '@/domain/shared/TSide';

class Preview3DController {
    constructor(
        private readonly _engine: I3DEngine,
        private readonly _viewport: IViewportEngine3D,
        private readonly _camera: ICameraController,
        private readonly _foldable?: IFoldableStrategy,
    ) {}

    get camera(): ICameraController {
        return this._camera;
    }

    applyCanvasTexture(side: TSide, snapshot: TCanvasSnapshot): void {
        this._engine.applyCanvasTexture(side, snapshot);
    }

    dispose(): void {
        this._engine.dispose();
    }

    onAfterRender(callback: () => void): () => void {
        return this._viewport.onAfterRender(callback);
    }

    resize(): void {
        this._viewport.resize();
    }

    setFold(angleRad: number): void {
        this._foldable?.setFold(angleRad);
    }
}

export { Preview3DController };
